import { useEffect, useState } from "react";

export const useLiveTime = (intervalMs = 10000): Date => {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, intervalMs);

    return () => clearInterval(timer);
  }, [intervalMs]);

  return time;
};
